var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect, useCallback } from "react";
import { createContext, useContext } from "react";
import { useLibZLInstance } from "./LibZLInstanceProvider";
export const CloudStreamInstanceContext = createContext(null);
export const useCloudStreamInstance = () => useContext(CloudStreamInstanceContext);
export const CloudStreamInstanceProvider = ({ projectName, configure, children }) => {
    const libZl = useLibZLInstance();
    const [cloudstream, setCloudStream] = useState(null);
    const createCloudStreamInstance = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!libZl) {
            return;
        }
        const cloudstream = libZl.cloudstream(projectName);
        const resolvedCloudStream = cloudstream instanceof Promise ? yield cloudstream : cloudstream;
        window.cloudstream = resolvedCloudStream;
        try {
            if (configure) {
                configure(resolvedCloudStream);
            }
        }
        catch (_a) {
            console.error("Failed to configure CloudStream instance");
        }
        setCloudStream(resolvedCloudStream);
    }), [libZl, projectName, configure]);
    useEffect(() => {
        createCloudStreamInstance();
    }, [createCloudStreamInstance]);
    return (React.createElement(CloudStreamInstanceContext.Provider, { value: cloudstream }, children));
};
